import React, { useEffect } from 'react';
import './DisclaimerModal.css';

interface DisclaimerModalProps {
  isOpen: boolean;
  onClose: () => void;
  language: 'en' | 'de';
}

export const DisclaimerModal: React.FC<DisclaimerModalProps> = ({
  isOpen,
  onClose,
  language
}) => {
  // Close modal on escape key
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const content = {
    de: {
      title: 'Wichtige Hinweise',
      text: `Diese App bietet eine Suche in einer Datenbank zur Berechnung des Kohlenhydratgehalts von Lebensmitteln, um den Alltag von Menschen mit Diabetes zu erleichtern.

Die Suchergebnisse basieren auf öffentlich verfügbaren Datenbanken (Schweizer Nährwertdatenbank, USDA FoodData Central, Open Food Facts). Begriffe wurden teilweise automatisch übersetzt. Die Produktdaten können fehlerhaft und unvollständig sein und sollten daher nur als Hilfsmittel zusammen mit anderen Informationsquellen dienen.

Diese App sollte nicht als alleinige Quelle für gesundheitsbezogene Entscheidungen genutzt werden. Bitte verwende im Zweifelsfall die Nährwertangaben des Herstellers oder konsultiere Deinen Diabetesberater oder Arzt.

Diese App speichert Deine Einstellungen und eigenen Daten lokal auf Deinem Gerät im Browser-Speicher. Es werden keine Daten an externe Server gesendet und wir verwenden keine Tracking- oder Analyse-Cookies.`,
      button: 'Verstanden'
    },
    en: {
      title: 'Important Notice',
      text: `This app provides a database search for calculating carbohydrate content in foods to help simplify daily life for people with diabetes.

The search results are based on publicly available databases (Swiss Food Composition Database, USDA FoodData Central, Open Food Facts). Terms have been partially automatically translated. The product data may be incorrect and incomplete and should therefore only be used as a tool alongside other information sources.

This app should not be used as the sole source for health-related decisions. When in doubt, please use the manufacturer's nutritional information or consult your diabetes counselor or doctor.

This app stores your preferences and custom data locally on your device using browser storage. No data is sent to external servers, and we don't use tracking or analytics cookies.`,
      button: 'Understood'
    }
  };

  const { title, text, button } = content[language];

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{title}</h2>
        </div>
        
        <div className="modal-body">
          {text.split('\n\n').map((paragraph, index) => (
            <p key={index} className="disclaimer-paragraph">
              {paragraph}
            </p>
          ))}
        </div>
        
        <div className="modal-footer center">
          <button 
            className="button button-primary"
            onClick={onClose}
          >
            {button}
          </button>
        </div>
      </div>
    </div>
  );
};